module.exports = "mutation ($id: ID!) {\n  PageDelete(id: $id) {\n    id\n  }\n}\n"